import { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);
  const tRef = useRef();

  useEffect(() => {
    const sessionId = params.get('session_id');
    if (!sessionId) { setStatus('error'); return; }
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === 'paid') {
          setStatus('paid');
          await checkAuth();
          setTimeout(() => navigate('/pro', { replace: true }), 1200);
          return;
        }
        if (data.payment_status === 'failed' || data.payment_status === 'expired') {
          setStatus('failed'); return;
        }
      } catch { /* ignore */ }
      setAttempts(a => a + 1);
      if (attempts < 20) tRef.current = setTimeout(poll, 2000);
      else setStatus('timeout');
    };
    poll();
    return () => clearTimeout(tRef.current);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center text-stone-100 p-6">
      <div className="text-center max-w-md">
        {status === 'checking' && (
          <>
            <Loader2 className="mx-auto animate-spin text-orange-400 mb-4" size={40} />
            <div className="font-display text-3xl">On finalise ton abonnement...</div>
            <div className="text-stone-400 mt-2">Ça prend quelques secondes.</div>
          </>
        )}
        {status === 'paid' && (
          <>
            <CheckCircle2 className="mx-auto text-orange-400 mb-4" size={48} />
            <div className="font-display text-4xl">Bienvenue chez Pro !</div>
            <div className="text-stone-400 mt-2">Redirection...</div>
          </>
        )}
        {(status === 'failed' || status === 'timeout' || status === 'error') && (
          <>
            <XCircle className="mx-auto text-red-400 mb-4" size={48} />
            <div className="font-display text-3xl">Paiement non confirmé</div>
            <div className="text-stone-400 mt-2">Reviens plus tard ou contacte-nous.</div>
            <button onClick={() => navigate('/pro')} className="btn-primary mt-6">Retour</button>
          </>
        )}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center text-stone-100 p-6">
      <div className="text-center max-w-md">
        <div className="font-display text-4xl">Paiement annulé</div>
        <div className="text-stone-400 mt-2">Pas de souci, tu peux réessayer quand tu veux.</div>
        <button data-testid="back-pro-btn" onClick={() => navigate('/pro')} className="btn-primary mt-6">Retour à Pro</button>
      </div>
    </div>
  );
}
